import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { withdrawalsQueries } from '@/services/withdrawals/withdrawals.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageWithdrawals = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('manageWithdrawals', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: withdrawalsQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
